module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step1-1-99188563fef8d8bdc02c5f02ef397a3b.gif";